export const companiesCompanyIdAppGroups = "/companies/:company_id/app_groups";
